import CrudBase from '../../../CrudBase';
import axios from '../../../../axios-common';

class GoalSalesPeriodApi extends CrudBase {
	getGoalSalesPeriod = (params) => axios.get(`${this.endpoint}/get-by`, params);

	defaultMethods = {
		getGoalSalesPeriod: this.getGoalSalesPeriod,
	};
}

const goalSalesPeriod = new GoalSalesPeriodApi('api/v1/goal-sales-period');

export default goalSalesPeriod.defaultMethods;
